import angular from 'angular'

angular.module('eficienciaFiscalModule').component('efFullscreenLoading', {
    bindings: {
        message: '<'
    },
    template: `
    <div class="pg-loading-screen pg-loading" style="background-color: rgb(255, 255, 255);">
        <div class="pg-loading-inner">
            <div class="pg-loading-center-outer">
                <div class="pg-loading-center-middle">
                    <h1 class="pg-loading-logo-header">
                        <img width="300px" class="pg-loading-logo" src="/assets/img/logo.png"/>
                    </h1>
                    <div class="pg-loading-html pg-loaded">
                        <p class="loading-message">
                            {{$ctrl.message}}
                        </p>
                        <div class="sk-folding-cube">
                            <div class="sk-cube1 sk-cube"></div>
                            <div class="sk-cube2 sk-cube"></div>
                            <div class="sk-cube4 sk-cube"></div>
                            <div class="sk-cube3 sk-cube"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `
})
